import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content type4" };
const _hoisted_2 = { class: "d-flex align-center" };
const _hoisted_3 = { class: "cy-date-picker multi-date-picker-activator" };
import CardSection from '@/components/Common/CardSection.vue';
import InputRow from '@/components/Form/InputRow.vue';
import RangeInput from '@/components/Form/RangeInput.vue';
import SearchInputWrapper from '@/components/Form/SearchInputWrapper.vue';
import Select from '@/components/Form/Select.vue';
import SearchInput from '@/components/Form/SearchInput.vue';
import { computed, ref, } from 'vue';
import { format, subMonths, } from 'date-fns';
import dateFormatType from '@/constants/dateFormatType';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const pickerData = ref([
            format(subMonths(new Date(), 1), dateFormatType.MONTH),
            format(new Date(), dateFormatType.MONTH),
        ]);
        const dateToString = computed(() => pickerData.value.join(' ~ '));
        const handleClickStartDateMonthly = () => {
            console.log('start');
        };
        const handleClickEndDateMonthly = () => {
            console.log('end');
        };
        const handleClickPickerSubmit = () => {
            console.log('submit');
        };
        const handleClickClosedBtn = () => {
            console.log('closed');
        };
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_vue_datepicker_action_row = _resolveComponent("vue-datepicker-action-row");
            const _component_vue_datepicker = _resolveComponent("vue-datepicker");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", null, [
                    _createVNode(InputRow, {
                        "head-col": 3,
                        label: "테스트"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                                ref: "workerNameRef",
                                density: "compact",
                                variant: "outlined",
                                "hide-details": "auto",
                                "validate-on": "blur",
                                placeholder: "플레이스홀더"
                            }, null, 512 /* NEED_PATCH */)
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _createVNode(CardSection, { title: "카드" }, {
                    default: _withCtx(() => [
                        _createVNode(InputRow, {
                            "head-col": 3,
                            label: "테스트"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    ref: "workerNameRef",
                                    density: "compact",
                                    variant: "outlined",
                                    "hide-details": "auto",
                                    "validate-on": "blur",
                                    placeholder: "플레이스홀더"
                                }, null, 512 /* NEED_PATCH */)
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(InputRow, {
                            "head-col": 3,
                            label: "테스트",
                            "is-required": ""
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    ref: "workerNameRef",
                                    density: "compact",
                                    variant: "outlined",
                                    "hide-details": "auto",
                                    "validate-on": "blur",
                                    placeholder: "플레이스홀더"
                                }, null, 512 /* NEED_PATCH */)
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(InputRow, {
                            "head-col": 3,
                            label: "테스트"
                        }, {
                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                                _createTextVNode(" 일반 텍스트 ")
                            ])),
                            _: 1 /* STABLE */,
                            __: [1]
                        }),
                        _createVNode(InputRow, {
                            "head-col": 3,
                            label: "테스트",
                            "is-normal-text-state": ""
                        }, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createTextVNode(" 여백 보정 ")
                            ])),
                            _: 1 /* STABLE */,
                            __: [2]
                        }),
                        _createVNode(InputRow, {
                            "head-col": 3,
                            label: "테스트",
                            "is-vertical-label": ""
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    ref: "workerNameRef",
                                    density: "compact",
                                    variant: "outlined",
                                    "hide-details": "auto",
                                    "validate-on": "blur",
                                    placeholder: "플레이스홀더"
                                }, null, 512 /* NEED_PATCH */)
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(InputRow, {
                            "head-col": 3,
                            label: "테스트"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_component_v_text_field, {
                                        density: "comfortable",
                                        variant: "outlined",
                                        "hide-details": "auto"
                                    }),
                                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mx-2" }, " ~ ", -1 /* CACHED */)),
                                    _createVNode(_component_v_text_field, {
                                        density: "comfortable",
                                        variant: "outlined",
                                        "hide-details": "auto"
                                    })
                                ])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                _cache[4] || (_cache[4] = _createElementVNode("h4", null, " 범위 관련 range ", -1 /* CACHED */)),
                _createVNode(RangeInput, null, {
                    head: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                            class: "ta-c-input",
                            density: "comfortable",
                            variant: "outlined",
                            "hide-details": "auto",
                            maxlength: 10,
                            oninput: "javascript: this.value = this.value.replace(/[^0-9.]/g, '');",
                            "validate-on": "blur"
                        })
                    ]),
                    tail: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                            class: "ta-c-input",
                            density: "comfortable",
                            variant: "outlined",
                            "hide-details": "auto",
                            maxlength: 10,
                            oninput: "javascript: this.value = this.value.replace(/[^0-9.]/g, '');",
                            "validate-on": "blur"
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                _cache[5] || (_cache[5] = _createElementVNode("h4", null, " 검색 컴포넌트 ", -1 /* CACHED */)),
                _createVNode(SearchInputWrapper, null, {
                    default: _withCtx(() => [
                        _createCommentVNode(" 검색 필터 "),
                        _createVNode(Select, {
                            class: "search-select",
                            title: _ctx.$t('common.search'),
                            items: ['1', '2', '3']
                        }, null, 8 /* PROPS */, ["title"]),
                        _createVNode(SearchInput, { class: "search-text-field" })
                    ]),
                    _: 1 /* STABLE */
                }),
                _cache[6] || (_cache[6] = _createElementVNode("h4", null, " 검색 컴포넌트 셀렉트 없음 ", -1 /* CACHED */)),
                _createVNode(SearchInput, { class: "search-text-field" }),
                _cache[7] || (_cache[7] = _createElementVNode("h4", null, "date picker month + range", -1 /* CACHED */)),
                _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(pickerData.value) + " ", 1 /* TEXT */),
                    _createVNode(_component_vue_datepicker, {
                        modelValue: pickerData.value,
                        "onUpdate:modelValue": [
                            _cache[0] || (_cache[0] = ($event) => ((pickerData).value = $event)),
                            handleClickPickerSubmit
                        ],
                        teleport: true,
                        "month-picker": "",
                        position: "left",
                        range: "",
                        "model-type": "yyyy-MM",
                        format: "yyyy-MM",
                        "hide-date": "",
                        onRangeStart: handleClickStartDateMonthly,
                        onRangeEnd: handleClickEndDateMonthly,
                        onClosed: handleClickClosedBtn
                    }, {
                        "action-row": _withCtx((props) => [
                            _createVNode(_component_vue_datepicker_action_row, _mergeProps(props, { "display-format": "yyyy-MM" }), null, 16 /* FULL_PROPS */)
                        ]),
                        "dp-input": _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_v_text_field, {
                                    width: "200",
                                    value: dateToString.value,
                                    variant: "outlined",
                                    density: "compact",
                                    readonly: "",
                                    "hide-details": "",
                                    class: "cy-cal-input",
                                    "bg-color": "white",
                                    "prepend-inner-icon": "mdi-calendar-month-outline"
                                }, null, 8 /* PROPS */, ["value"])
                            ])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"])
                ])
            ]));
        };
    }
});
